/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AutomatedSearchStatus } from './';
import {
    AutomatedSearchStatusFromJSON,
    AutomatedSearchStatusFromJSONTyped,
    AutomatedSearchStatusToJSON,
} from './';
import type { SourcingSearchFreelancer } from './';
import {
    SourcingSearchFreelancerFromJSON,
    SourcingSearchFreelancerFromJSONTyped,
    SourcingSearchFreelancerToJSON,
} from './';

/**
 * 
 * @export
 * @interface AutomatedSearchResponse
 */
export interface AutomatedSearchResponse {
    /**
     * 
     * @type {string}
     * @memberof AutomatedSearchResponse
     */
    briefId: string;
    /**
     * 
     * @type {AutomatedSearchStatus}
     * @memberof AutomatedSearchResponse
     */
    status: AutomatedSearchStatus;
    /**
     * 
     * @type {Array<SourcingSearchFreelancer>}
     * @memberof AutomatedSearchResponse
     */
    results: Array<SourcingSearchFreelancer>;
    /**
     * 
     * @type {number}
     * @memberof AutomatedSearchResponse
     */
    totalElements: number;
}

/**
 * Check if a given object implements the AutomatedSearchResponse interface.
 */
export function instanceOfAutomatedSearchResponse(value: object): value is AutomatedSearchResponse {
    if (!('briefId' in value) || value['briefId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    return true;
}

export function AutomatedSearchResponseFromJSON(json: any): AutomatedSearchResponse {
    return AutomatedSearchResponseFromJSONTyped(json, false);
}

export function AutomatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomatedSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'briefId': json['briefId'],
        'status': AutomatedSearchStatusFromJSON(json['status']),
        'results': ((json['results'] as Array<any>).map(SourcingSearchFreelancerFromJSON)),
        'totalElements': json['totalElements'],
    };
}

export function AutomatedSearchResponseToJSON(value?: AutomatedSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'briefId': value['briefId'],
        'status': AutomatedSearchStatusToJSON(value['status']),
        'results': ((value['results'] as Array<any>).map((v) => SourcingSearchFreelancerToJSON(v))),
        'totalElements': value['totalElements'],
    };
}

